import { render, staticRenderFns } from "./cartTrapezSSL.vue?vue&type=template&id=21bb3268&"
import script from "./cartTrapezSSL.vue?vue&type=script&lang=js&"
export * from "./cartTrapezSSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports